var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layout" }, [
    _c(
      "div",
      { staticClass: "layout_nav" },
      [_c("Nav", _vm._b({}, "Nav", _vm.getRol, false))],
      1
    ),
    _c(
      "div",
      { staticClass: "layout_center" },
      [
        _c("div", { staticClass: "layout_row" }, [
          _c("div", { staticClass: "layout_colum" }, [
            _c(
              "div",
              { staticClass: "ctn_bread" },
              [_c("Welcome", _vm._b({}, "Welcome", _vm.getUser, false))],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "layout_colum" },
            [
              _c("Snackbar", {
                attrs: {
                  visible: _vm.getAlert.snackbar,
                  text: _vm.getAlert.text,
                },
              }),
              _c(
                "div",
                { staticClass: "ctn_indicator" },
                [
                  _c("Indicator", {
                    attrs: {
                      active: _vm.getListDeviceSucess.length,
                      activeText: "Exitoso",
                      inactive: _vm.deviceInactive,
                      inactiveText: "Fallido",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("TableComp"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }